/**
 * Created by sunshine on 2016/12/14.
 */
import Vue from 'vue'
import VueResource from 'vue-resource'
import contact from './contact'
// Resource
Vue.use(VueResource)
new Vue({
  el: '#app',
  template: '<contact/>',
  components: { contact }
})



// WEBPACK FOOTER //
// ./src/pages/contact/index.js